/** Tokens visuais — organizadores (marca TNV) */
export const ORGANIZADORES_ACCENT = "#F96030";
export const ORGANIZADORES_INK = "#1a2035";

export const organizadoresToolbarSx = {
  mb: 2,
  p: 2,
  borderRadius: 2,
  bgcolor: "grey.50",
  border: "1px solid",
  borderColor: "grey.200",
  borderLeft: `4px solid ${ORGANIZADORES_ACCENT}`,
};

export const modalPaperSx = {
  borderRadius: 3,
  overflow: "hidden",
  maxHeight: "92vh",
  display: "flex",
  flexDirection: "column" as const,
  width: { xs: "100%", sm: "98vw" },
  maxWidth: 960,
};

export const modalHeaderSx = {
  px: 3,
  py: 2.5,
  flexShrink: 0,
  background: `linear-gradient(135deg, ${ORGANIZADORES_INK} 0%, #2d3561 100%)`,
  color: "#fff",
  borderBottom: `3px solid ${ORGANIZADORES_ACCENT}`,
};

export const fieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 1.5,
    bgcolor: "background.paper",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "grey.500",
    borderWidth: 1,
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "text.secondary",
  },
};

export const saveButtonSx = {
  background: `linear-gradient(195deg, ${ORGANIZADORES_ACCENT}, #e04a1a)`,
};

export const sectionTitleSx = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  mb: 2,
  pb: 1,
  borderBottom: "1px solid",
  borderColor: "grey.200",
};
